import { render } from "./PaymentTable.vue?vue&type=template&id=3c99c4db&scoped=true"
import script from "./PaymentTable.vue?vue&type=script&lang=ts"
export * from "./PaymentTable.vue?vue&type=script&lang=ts"

import "./PaymentTable.vue?vue&type=style&index=0&id=3c99c4db&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3c99c4db"

export default script